const spreadsheetColumnsToInternalColumns = {
  "Model Year": "modelYear",
  Make: "make",
  Model: "modelName",
  Type: "type",
  "Range (km)": "range",
  "ZEV Class": "zevClass",
  "Vehicle Class and Interior Volume": "vehicleClassInteriorVolume",
  "ZEV Supply Forecast": "totalSupplied",
};

export default spreadsheetColumnsToInternalColumns;
